export enum ButtonType {
  Primary,
  Secondary,
  Tertiary,
  Quaternary,
}
